import { createMergeReducer } from '../utils/reducer'

type Features = 'useCarousel' | 'useMFA' | 'useFaq' | 'useContactUs' | 'useAmabot' | 'hideReviews'
  | 'usePlayer' | 'useSixteenByNine' | 'useOtherFormats' | 'useTermsAndFeedback'

export type FeatureToStatus = { [feature in Features]?: boolean }

export const reducer = createMergeReducer(
  t => t.features,
  {} as FeatureToStatus
)
